<template>
  <L1>
    <template slot="slot_title">
      <RadioTop :options="['今日', '自訂']" :defaultValue="datetype" @input="datetype=$event"/>
      <DateRange v-if="datetype==='自訂'" :defaultValue="range" :style="{marginLeft: 0}" @input="range=$event"/>
      <!-- <div class="langRadio">
        <div>導覽語言</div>
        <input type="radio" value="tw" label="中文" v-model="lang">
        <input type="radio" value="en" label="英文" v-model="lang">
        <input type="radio" value="ja" label="日文" v-model="lang">
      </div> -->
      <SqrBtn :iconSize="20" @click="pi=!pi" :style="{marginLeft: 'auto', fontSize: '18px'}" :text="pi?'切換數字報表':'切換圖表數據'" :bg="'var(--color-checked)'" :icon="'switch'"/>
    </template>
    <PiView v-if="pi" :rows="rows" :areas="areas"/>
    <Table v-else :rows="rows" :style="{marginInline: '22px 22px'}">
      <template slot="slot_head">
        <th :style="{textAlign: 'start'}">地點名稱</th>
        <th>點擊次數</th>
        <th>(語音1)</th>
        <th>(語音2)</th>
        <th>(語音3)</th>
        <th>圖文解說</th>
        <th>(影音1)</th>
        <th>(影音2)</th>
        <th>(影音3)</th>
        <th :style="{width: '100px'}"></th>
      </template>
      <tr slot-scope="item" :style="{height: '64px', border: 'none'}">
        <td :style="{textAlign: 'start'}">{{item.item.name}}</td>
        <td>{{item.item.num}}</td>
        <td>{{item.item.audio[0] ? item.item.audio[0].num : '-'}} {{item.item.audio[0] ? `(${item.item.audio[0].name.slice(0, 1)})` : ''}}</td>
        <td>{{item.item.audio[1] ? item.item.audio[1].num : '-'}} {{item.item.audio[1] ? `(${item.item.audio[1].name.slice(0, 1)})` : ''}}</td>
        <td>{{item.item.audio[1] ? item.item.audio[2].num : '-'}} {{item.item.audio[2] ? `(${item.item.audio[2].name.slice(0, 1)})` : ''}}</td>
        <td>{{item.item.info}}</td>
        <td>{{item.item.video[0] ? item.item.video[0].num : '-'}}</td>
        <td>{{item.item.video[1] ? item.item.video[1].num : '-'}}</td>
        <td>{{item.item.video[2] ? item.item.video[2].num : '-'}}</td>
        <td></td>
      </tr>
    </Table>
  </L1>
</template>

<script>
import PiView from './MapsSummaryPi.vue'
import Table from '../../components/tables/t2.vue'
import SqrBtn from '../../components/btn/sqr40016.vue'
import DateRange from '../../components/input/dateRange.vue'
import RadioTop from '../../components/radio/r1.vue'
import L1 from '../../components/layout/L1.vue'
import { getapi } from '../../store/fetch'
export default {
  components: {
    L1,
    RadioTop,
    DateRange,
    SqrBtn,
    Table,
    PiView
  },
  data () {
    return {
      // lang: 'tw',
      datetype: '今日',
      pi: false,
      range: {
        start: this.moment().format('yyyy-MM-DD'),
        end: this.moment().format('yyyy-MM-DD')
      },
      rows: []
    }
  },
  computed: {
    areas () {
      return Array.from(new Set(this.rows.map(e => e.area._id))).map(_id => {
        return this.rows.map(e => e.area).find(e => e._id === _id)
      })
    }
  },
  watch: {
    lang () {
      this.getdata()
    },
    datetype () {
      if (this.datetype === '今日') {
        this.range = {
          start: this.moment().format('yyyy-MM-DD'),
          end: this.moment().format('yyyy-MM-DD')
        }
      }
    },
    range () {
      if (this.range.start && this.range.end) {
        this.getdata()
      }
    }
  },
  async mounted () {
    await this.getdata()
  },
  methods: {
    async getdata () {
      const data = await getapi('tourGuide/summary?' + new URLSearchParams({ ...this.range }))
      this.rows = data
    }
  }
}
</script>

<style lang="scss" scoped>

.langRadio {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 25px;
  letter-spacing: 0.1em;
  color: var(--color-checked);
  gap: 15px;
  &>:nth-child(1) {
    margin-left: 15px;
  }
  input[type=radio] {
    padding-inline: 24px;
    min-width: 95px;
    height: 40px;
    border: none;
    background-color: #B8B8B8;
    appearance: none;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    &::before {
      content: attr(label);
    }
    &:checked {
      background-color: var(--color-checked);
    }
  }

}
</style>
